import React, { useEffect } from 'react';
import { useUnderReviewStore } from 'src/store/under-review';
import { useApplicationStore } from 'src/store/application';
import { useAuthStore } from 'src/store/auth';
import { Modal } from '../Modal';
import './UnderReview.scss';

export const UnderReview: React.FC = () => {
  const { 
    isModalOpen,
    firstName, 
    setModalOpen, 
    setDontShowAgain,
    checkUnderReviewStatus
  } = useUnderReviewStore();
  
  const { applications } = useApplicationStore();
  const { isAuthenticated } = useAuthStore();

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleDontShowAgain = () => {
    setDontShowAgain();
  };

  // Check under review status on mount and when underwriting result changes
  useEffect(() => {
    if (isAuthenticated) {
      checkUnderReviewStatus();
    }
  }, [isAuthenticated, checkUnderReviewStatus]);


  // Update first name when applications change
  useEffect(() => {
    if (applications.length > 0 && applications[0]?.applicants?.length > 0) {
      const firstName = applications[0].applicants[0].firstName || '';
      useUnderReviewStore.setState({ firstName });
    }
  }, [applications]);

  if (!isModalOpen) return null;

  return (
    <Modal isOpen={isModalOpen} onClose={handleClose} className="under-review-modal">
      <div className="under-review">
        <div className="under-review__image">
          <img 
            src="/images/modalUnderReview.jpg" 
            alt="Application under review"
            className="under-review__image-content max-1m:hidden"
          />
          <h2 className="under-review__title">
            Your application is<br />under review
          </h2>
        </div>

        <div className="under-review__content">
          <div className="under-review__text">
            <p className="under-review__paragraph">
              Hi {firstName ? `${firstName}, ` : ''}thanks for submitting your application. 
              We know this is frustrating but we need to do a little more review of your application.
            </p>
            <p className="under-review__paragraph">
              During this period, your application is read-only (no edits to dependents, plans, or pricing). 
              We hope to have this review done as quickly as possible and will let you know as soon as it's ready.
            </p>
          </div>

          <button 
            className="under-review__dont-show"
            onClick={handleDontShowAgain}
          >
            Don't show this message again
          </button>
        </div>
      </div>
    </Modal>
  );
};